import React from 'react';
import { FieldError } from 'react-hook-form';
import { ChevronDown } from 'lucide-react';

type SelectOption = {
  id: string;
  label: string;
  disabled?: boolean;
  selected?: boolean;
};

const SelectInput: React.FC<{
  id: string;
  label?: string;
  register: any;
  placeholder?: string;
  options: SelectOption[];
  error?: FieldError;
  callback?: Function;
  selectClassName?: string;
}> = ({
  id,
  label,
  register,
  placeholder,
  options,
  error,
  callback,
  selectClassName = 'block font-main text-neutral-900 text-body-sm appearance-none w-full bg-white border border-neutral-300 hover:border-neutral-400 pl-4 pr-10 rounded-input shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 h-12 transition-colors',
}) => {
  const errorComponent = error?.message && (
    <p className="italic font-main text-body-sm text-danger-600 mt-1">{error.message}</p>
  );

  if (placeholder) {
    options = [
      {
        id: '',
        label: placeholder,
        disabled: false,
        selected: true,
      },
      ...options,
    ];
  }

  return (
    <div className="inline-block relative w-full">
      {label && (
        <label className="block font-main text-neutral-700 text-body-sm font-medium mb-2" htmlFor={id}>
          {label}
        </label>
      )}
      <div className="inline-block relative w-full">
        <select
          {...register(id)}
          onChange={(e) => {
            register(id).onChange(e);
            if (typeof callback === 'function') {
              callback(e.target.value);
            }
          }}
          id={id}
          className={selectClassName}
        >
          {options.map((opt: SelectOption, i) => (
            <option value={opt.id} key={i} disabled={!!opt.disabled}>
              {opt.label}
            </option>
          ))}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3 text-neutral-500">
          <ChevronDown size={18} />
        </div>
      </div>
      {errorComponent}
    </div>
  );
};

export default SelectInput;
